import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { CompanyZrc } from './company-zrc';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-company-zrc-modal-update',
  templateUrl: './company-zrc-modal-update.component.html'
})
export class CompanyZrcModalUpdateComponent extends BaseModalUpdateComponent<CompanyZrc> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<CompanyZrc>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
